import { defineMessages } from "react-intl";

import {
	renalReplacementTherapyTypeMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/waiting-list-data/renalReplacementTherapy";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	renalReplacementTherapy: {
		id: "ktx.form.renal_replacement_therapy.title",
		defaultMessage: "Jelenlegi vesepótló kezelés"
	},
	diseases: {
		id: "ktx.form.renal_replacement_therapy.value",
		defaultMessage: "Jelenlegi vesepótló kezelés típusa"
	},
	other: {
		id: "ktx.form.renal_replacement_therapy.other",
		defaultMessage: "Egyéb kezelés"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["renalReplacementTherapyType"],
						label: messages.diseases,
						errorMessages: genericErrorMessages,
						input: {
							type: "select",
							props: {
								labels: renalReplacementTherapyTypeMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["renalReplacementTherapyTypeOther"],
						label: messages.other,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_renalReplacementTherapy",
	value: {
		schemaId: "renalReplacementTherapy",
		title: messages.renalReplacementTherapy,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
